// LUMINA · constants/baziData.js
// All lookup tables, color constants, and style tokens
// shared across the application.

// ── Design tokens ─────────────────────────────────────────────────────────────
export const C = {
  bg:"#FDFBF7", panel:"rgba(255,255,255,.70)", panel2:"rgba(255,255,255,.88)",
  border:"rgba(255,255,255,.45)", border2:"rgba(212,175,55,.35)",
  gold:"#D4AF37", goldDim:"#B8940A", goldDark:"rgba(212,175,55,.10)", goldGlow:"rgba(212,175,55,.22)",
  emerald:"#064E3B", emeraldMid:"#065F46", emeraldDim:"rgba(6,78,59,.08)",
  cyan:"#0891B2", cyanDim:"rgba(8,145,178,.10)", sage:"#059669", sageDim:"rgba(5,150,105,.10)",
  fire:"#DC2626", wood:"#16A34A", water:"#2563EB", earth:"#D4AF37", metal:"#78716C",
  stress:"#DC2626", mist:"#1A202C", mist2:"#2D3748", mist3:"#4A5568", mist4:"#718096", mist5:"#E2E8F0",
};
export const ECOL = { Fire:C.fire, Wood:C.wood, Water:C.water, Earth:C.earth, Metal:C.metal };
export const EZH  = { Fire:"火", Wood:"木", Water:"水", Earth:"土", Metal:"金" };
export const TG   = ["甲","乙","丙","丁","戊","己","庚","辛","壬","癸"];
export const DZ   = ["子","丑","寅","卯","辰","巳","午","未","申","酉","戌","亥"];
export const TG_EN= ["Jia","Yi","Bing","Ding","Wu","Ji","Geng","Xin","Ren","Gui"];
export const DZ_EN= ["Zi","Chou","Yin","Mao","Chen","Si","Wu","Wei","Shen","You","Xu","Hai"];
export const SE   = {"甲":"木","乙":"木","丙":"火","丁":"火","戊":"土","己":"土","庚":"金","辛":"金","壬":"水","癸":"水"};
export const BE   = {"子":"水","丑":"土","寅":"木","卯":"木","辰":"土","巳":"火","午":"火","未":"土","申":"金","酉":"金","戌":"土","亥":"水"};
export const EEN  = {"木":"Wood","火":"Fire","土":"Earth","金":"Metal","水":"Water"};
export const JDAY = [6,4,6,5,6,6,7,7,8,8,7,7];


export const T = {
  en: {
    // Nav
    audit:"Audit", pricing:"Pricing", myReports:"My Reports", myProfile:"My Profile",
    signIn:"Sign in", register:"Register free", signOut:"Sign out",
    // Audit page
    generateTitle:"Generate Your Energy Audit",
    generateSub:"Enter your birth details · Bazi + Five Elements + Ten Gods + Major Cycles + Deity Practice",
    yourName:"Your Name", year:"Year", month:"Month", day:"Day", hour:"Hour (0-23)", minute:"Min",
    gender:"Gender", male:"Male", female:"Female", birthLocation:"Birth Location",
    primaryConcern:"Primary Concern", locationPlaceholder:"City, Country",
    concernPlaceholder:"e.g. Career, relationships, health, spiritual growth…",
    generateBtn:"GENERATE ENERGY AUDIT ▶", computing:"COMPUTING…",
    signInBanner:"Sign in to save reports and view your full history",
    // Report
    fourPillars:"Four Pillars · 四柱", fiveElements:"Five Elements Balance",
    energyMetrics:"Energy Metrics", vitality:"Vitality Index", stress:"Stress / Blockage",
    momentum:"Cycle Momentum", relational:"Relational Field",
    tenGods:"Ten Gods Analysis · 十神", dayMasterLabel:"Day Master",
    dayMasterSub:"influences all relationships",
    majorCycles:"Major Luck Cycles · 大运", cycleSub:"Each cycle spans 10 years — your life's energetic seasons",
    annualReading:"2026 Annual Reading · 流年",
    domainAnalysis:"Life Domain Analysis · 人生领域",
    wealth:"Wealth & Career", love:"Love & Relationships", health:"Health & Vitality", spiritual:"Spiritual Growth",
    aiDiagnostic:"AI Diagnostic · Energy Analysis",
    tantraRec:"Tantric Practice Recommendation · 本尊修持",
    retreatRec:"Retreat Recommendation",
    retreatDesc:"Based on your chart analysis, a focused retreat addressing {elem} excess would bring significant transformation.",
    retreatCenter:"Naropa Six Yogas · Dzokchen · Nepal or Vietnam retreat centers available",
    newAudit:"New Audit", disclaimer:"LUMINA Energy Audit · Not medical advice · For guidance only",
    now:"Now", favorable:"Favorable — energy supports growth", stable:"Stable period, steady progress", challenging:"Challenging — consolidate and be cautious",
    // Profile
    profileTitle:"My Profile", profileSub:"Your birth data powers the LUMINA energy audit. All information is kept strictly confidential.",
    fullName:"Full Name", birthInfo:"Birth Information · 出生资料",
    birthLocation2:"Birth Location", locationHint:"e.g. Shanghai, China · Toronto, Canada · New York, USA",
    saveProfile:"SAVE PROFILE", saving:"Saving…", saved:"✓ Profile saved successfully",
    goAudit:"Generate My Energy Audit →",
    concerns:["Career & Wealth","Love & Relationships","Health & Vitality","Spiritual Growth","Life Direction"],
    // History
    noReports:"No Reports Yet", noReportsSub:"Generate your first energy audit to see it here",
    generateFirst:"Generate Audit →", reportsTitle:"My Reports",
    // Pricing
    pricingTitle:"Energy Plans · 能量计划", pricingSub:"Choose the plan that matches your energy goals · All plans include Bazi calculation",
    stripeNote:"Stripe-secured · Cancel anytime · All proceeds support dharma activities & retreat center construction",
    // Login
    welcomeBack:"Welcome back", loginSub:"Sign in to your LUMINA account",
    email:"Email", password:"Password", emailPlaceholder:"your@email.com",
    passwordPlaceholder:"••••••••", signingIn:"Signing in…", signInBtn:"SIGN IN",
    noAccount:"No account?", registerFree:"Register free",
    // Register
    createAccount:"Create your account", registerSub:"Free · L0 includes Bazi + Energy Score",
    minPassword:"Min 8 characters", creating:"Creating…", createBtn:"CREATE ACCOUNT",
    haveAccount:"Already have an account?",
    branch:"branch", dayMasterFull:"(element) — influences all relationships",
  },
  zh: {
    // Nav
    audit:"命盘", pricing:"套餐", myReports:"我的报告", myProfile:"个人资料",
    signIn:"登录", register:"免费注册", signOut:"退出",
    // Audit page
    generateTitle:"生成您的能量报告",
    generateSub:"输入出生信息 · 八字 + 五行 + 十神 + 大运 + 本尊修持",
    yourName:"姓名", year:"年", month:"月", day:"日", hour:"时（0-23）", minute:"分",
    gender:"性别", male:"男", female:"女", birthLocation:"出生地点",
    primaryConcern:"主要问题", locationPlaceholder:"城市，国家",
    concernPlaceholder:"例如：事业，感情，健康，灵性修持…",
    generateBtn:"生成能量报告 ▶", computing:"计算中…",
    signInBanner:"登录以保存报告并查看完整历史记录",
    // Report
    fourPillars:"四柱", fiveElements:"五行平衡",
    energyMetrics:"能量指标", vitality:"生命力指数", stress:"压力/阻滞",
    momentum:"运势动能", relational:"人际关系场",
    tenGods:"十神分析", dayMasterLabel:"日主",
    dayMasterSub:"影响所有关系领域",
    majorCycles:"大运走势", cycleSub:"每步大运十年 — 您人生的能量季节",
    annualReading:"2026年流年分析",
    domainAnalysis:"人生领域分析",
    wealth:"财运事业", love:"感情婚姻", health:"健康养生", spiritual:"灵性修持",
    aiDiagnostic:"AI诊断 · 能量分析",
    tantraRec:"本尊修持建议",
    retreatRec:"闭关修持推荐",
    retreatDesc:"根据您的命盘分析，针对{elem}过旺的专项闭关修持将带来显著转化。",
    retreatCenter:"那若六法 · 大圆满 · 尼泊尔或越南闭关中心",
    newAudit:"新建报告", disclaimer:"LUMINA能量报告 · 仅供参考，非医疗建议",
    now:"当前", favorable:"吉运 — 能量支持成长", stable:"平稳期，稳步前进", challenging:"注意期 — 宜稳健保守",
    // Profile
    profileTitle:"个人资料", profileSub:"您的出生数据是LUMINA能量报告的基础，所有信息严格保密。",
    fullName:"姓名", birthInfo:"出生信息",
    birthLocation2:"出生地点", locationHint:"例如：中国上海 · 加拿大多伦多 · 美国纽约",
    saveProfile:"保存资料", saving:"保存中…", saved:"✓ 资料保存成功",
    goAudit:"生成我的能量报告 →",
    concerns:["事业财运","感情婚姻","健康养生","灵性修持","人生方向"],
    // History
    noReports:"暂无报告", noReportsSub:"生成您的第一份能量报告",
    generateFirst:"生成报告 →", reportsTitle:"我的报告",
    // Pricing
    pricingTitle:"选择您的修持路径", pricingSub:"从免费体验到全面人生陪伴 · 所有套餐均含八字计算",
    stripeNote:"Stripe 安全支付 · 随时取消 · 收益支持关联闭关中心",
    // Login
    welcomeBack:"欢迎回来", loginSub:"登录您的LUMINA账户",
    email:"邮箱", password:"密码", emailPlaceholder:"您的邮箱",
    passwordPlaceholder:"••••••••", signingIn:"登录中…", signInBtn:"登 录",
    noAccount:"没有账户？", registerFree:"免费注册",
    // Register
    createAccount:"创建账户", registerSub:"免费 · L0包含八字+能量评分",
    minPassword:"至少8位字符", creating:"创建中…", createBtn:"创建账户",
    haveAccount:"已有账户？",
    branch:"地支", dayMasterFull:"（五行）— 影响所有关系领域",
  }
};


// ── Bazi calendar constants ──────────────────────────────────────────────────
export const LICHUN_EX={1902:5,1903:5,1904:5,1907:5,1908:5,1911:5,1912:5,1915:5,1916:5,1919:5,1920:5,1923:5,1924:5,1927:5,1928:5,1931:5,1932:5,1935:5,1936:5,1939:5,1940:5,1943:5,1944:5,1948:5,1952:5,1956:5,1960:5,1964:5,1968:5,1972:5,1976:5,1980:5,2017:3,2021:3,2025:3,2029:3,2033:3,2037:3,2041:3,2045:3,2049:3,2053:3,2057:3,2061:3,2065:3,2069:3,2073:3,2077:3,2081:3,2085:3,2089:3,2093:3,2097:3};

export const SHISHEN_MAP = {
  "甲":{"甲":"比肩","乙":"劫财","丙":"食神","丁":"伤官","戊":"偏财","己":"正财","庚":"七杀","辛":"正官","壬":"偏印","癸":"正印"},
  "乙":{"甲":"劫财","乙":"比肩","丙":"伤官","丁":"食神","戊":"正财","己":"偏财","庚":"正官","辛":"七杀","壬":"正印","癸":"偏印"},
  "丙":{"甲":"偏印","乙":"正印","丙":"比肩","丁":"劫财","戊":"食神","己":"伤官","庚":"偏财","辛":"正财","壬":"七杀","癸":"正官"},
  "丁":{"甲":"正印","乙":"偏印","丙":"劫财","丁":"比肩","戊":"伤官","己":"食神","庚":"正财","辛":"偏财","壬":"正官","癸":"七杀"},
  "戊":{"甲":"七杀","乙":"正官","丙":"偏印","丁":"正印","戊":"比肩","己":"劫财","庚":"食神","辛":"伤官","壬":"偏财","癸":"正财"},
  "己":{"甲":"正官","乙":"七杀","丙":"正印","丁":"偏印","戊":"劫财","己":"比肩","庚":"伤官","辛":"食神","壬":"正财","癸":"偏财"},
  "庚":{"甲":"偏财","乙":"正财","丙":"七杀","丁":"正官","戊":"偏印","己":"正印","庚":"比肩","辛":"劫财","壬":"食神","癸":"伤官"},
  "辛":{"甲":"正财","乙":"偏财","丙":"正官","丁":"七杀","戊":"正印","己":"偏印","庚":"劫财","辛":"比肩","壬":"伤官","癸":"食神"},
  "壬":{"甲":"食神","乙":"伤官","丙":"偏财","丁":"正财","戊":"七杀","己":"正官","庚":"偏印","辛":"正印","壬":"比肩","癸":"劫财"},
  "癸":{"甲":"伤官","乙":"食神","丙":"正财","丁":"偏财","戊":"正官","己":"七杀","庚":"正印","辛":"偏印","壬":"劫财","癸":"比肩"},
};
export const SS_EN = {"比肩":"Rob Wealth","劫财":"Competitor","食神":"Eating God","伤官":"Hurting Officer","偏财":"Indirect Wealth","正财":"Direct Wealth","七杀":"7 Killings","正官":"Direct Officer","偏印":"Indirect Resource","正印":"Direct Resource"};
export const SS_MEANING = {
  "比肩":{en:"Independent, self-reliant, competitive",zh:"独立自信，自力更生，竞争意识强"},
  "劫财":{en:"Partnership-oriented, volatile finances",zh:"合作共事，财运起伏，感情多波折"},
  "食神":{en:"Talented, fortunate, enjoys life",zh:"才华福气，口才出众，享受生活"},
  "伤官":{en:"Brilliant, unconventional, rebellious",zh:"聪明叛逆，才华横溢，不拘一格"},
  "偏财":{en:"Flexible wealth, social, business-minded",zh:"偏门财运，广交人际，父缘一般"},
  "正财":{en:"Stable income, faithful, practical",zh:"务实理财，感情专一，正当收入"},
  "七杀":{en:"Driven by pressure, bold, transformative",zh:"压力动力，竞争激烈，破坏中建设"},
  "正官":{en:"Principled, status-conscious, responsible",zh:"循规蹈矩，名誉地位，责任心强"},
  "偏印":{en:"Unconventional wisdom, spiritual depth",zh:"偏门学问，宗教缘深，思维独特"},
  "正印":{en:"Scholarly, supported by benefactors",zh:"学识渊博，贵人运强，母缘深厚"},
};
export const BRANCH_MAIN = {"子":"癸","丑":"己","寅":"甲","卯":"乙","辰":"戊","巳":"丙","午":"丁","未":"己","申":"庚","酉":"辛","戌":"戊","亥":"壬"};
export const JIAZI_60 = ["甲子","乙丑","丙寅","丁卯","戊辰","己巳","庚午","辛未","壬申","癸酉","甲戌","乙亥","丙子","丁丑","戊寅","己卯","庚辰","辛巳","壬午","癸未","甲申","乙酉","丙戌","丁亥","戊子","己丑","庚寅","辛卯","壬辰","癸巳","甲午","乙未","丙申","丁酉","戊戌","己亥","庚子","辛丑","壬寅","癸卯","甲辰","乙巳","丙午","丁未","戊申","己酉","庚戌","辛亥","壬子","癸丑","甲寅","乙卯","丙辰","丁巳","戊午","己未","庚申","辛酉","壬戌","癸亥"];
export const CHONG = {"子":"午","午":"子","丑":"未","未":"丑","寅":"申","申":"寅","卯":"酉","酉":"卯","辰":"戌","戌":"辰","巳":"亥","亥":"巳"};
export const SHENG = {"木":"火","火":"土","土":"金","金":"水","水":"木"};
export const KE_MAP = {"木":"土","土":"水","水":"火","火":"金","金":"木"};

// ── Shared style tokens ──────────────────────────────────────────────────────
export const IS = {background:"rgba(255,255,255,.80)",backdropFilter:"blur(8px)",border:"1px solid rgba(0,0,0,.12)",borderRadius:10,color:"#1A202C",fontFamily:"'Inter','Montserrat',Georgia,sans-serif",fontSize:15,padding:"10px 14px",outline:"none",width:"100%",boxSizing:"border-box"};
export const LS = {fontSize:11,letterSpacing:".18em",color:"#718096",marginBottom:6,display:"block",textTransform:"uppercase",fontFamily:"'Inter','Montserrat',sans-serif"};
export const BG = {background:"#064E3B",color:"#fff",border:"none",borderRadius:10,padding:"12px 0",fontSize:13,letterSpacing:".06em",fontWeight:"bold",cursor:"pointer",width:"100%",marginTop:8};
export const BO = {background:"transparent",border:"1px solid rgba(212,175,55,.50)",borderRadius:10,padding:"8px 18px",fontSize:13,letterSpacing:".06em",color:"#D4AF37",cursor:"pointer"};
